import { cx } from '@emotion/css';
import React from 'react';
import { Link } from '../../atoms';
import { Typography } from '../../electrons';
import { useWizardContentHeaderStyles } from './WizardContentHeader.styles';
export function WizardContentHeader(props) {
    const styles = useWizardContentHeaderStyles(props);
    return (React.createElement("div", { className: cx(props.className, styles.root), id: props.id },
        React.createElement(Typography, { variant: "h4", className: styles.headerText, id: `${props.step}__header` }, props.headerText),
        React.createElement(Typography, { variant: "body2", className: styles.subHeaderText, id: `${props.step}__subheader` },
            props.subHeaderText,
            props.href ? (React.createElement(Link, { id: `${props.step}__link`, href: props.href, target: "_blank", className: styles.hrefText }, props.hrefText)) : null)));
}
//# sourceMappingURL=WizardContentHeader.js.map